import React from 'react';
import Checkbox from '../../Inputs/Checkbox';
import RadioButton from '../../Inputs/Radiobutton';
import { FilterElementAttributes } from '../types/FilterElementAttributes';

const FilterCheckbox = ({
  filter,
  option,
  onChange,
}: FilterElementAttributes) => {
  return option ? (
    <label
      className="flex items-center justify-between py-1"
      key={option.id}
    >
      <span className="text-md">{option.label}</span>
      <span className="color-gray-500 flex items-center text-sm">
        <span className="text-small mr-1.5 text-gray-500">
          ({option.quantity})
        </span>
        {!filter.singleSelect && (
          <Checkbox
            inputSize="medium"
            checked={filter.selectedOptions.indexOf(option.id) != -1}
            onChange={() => onChange && onChange(filter.id, option.id)}
          />
        )}
        {filter.singleSelect && (
          <RadioButton
            inputSize="small"
            checked={filter.selectedOptions.indexOf(option.id) != -1}
            onChange={() => onChange && onChange(filter.id, option.id)}
          />
        )}
      </span>
    </label>
  ) : null;
};

export default FilterCheckbox;
